<template>
  <a
    v-if="!isLink"
    :href="undefined"
    class="artist-card relative"
    :style="{ backgroundImage: `url(${artistImage})` }"
    target="_blank"
  >
    <a
      v-if="artist.spotify_id"
      class="absolute spotify-icon"
      :href="`https://open.spotify.com/intl-es/artist/${artist.spotify_id}`"
      @click.prevent.stop="
        navigateToSpotify(
          `https://open.spotify.com/intl-es/artist/${artist.spotify_id}`
        )
      "
    >
      <icon :size="24" :img="require('@/assets/images/ic-spotify-white.svg')" />
    </a>
    <div class="absolute artist-name">{{ artist.name }}</div>
  </a>
  <a
    v-else
    :href="openLink ? artist.permalink : null"
    class="artist-card relative"
    target="_blank"
    :style="{ backgroundImage: `url(${artistImage})` }"
  >
    <a
      v-if="artist.spotify_id"
      class="absolute spotify-icon"
      :href="`https://open.spotify.com/intl-es/artist/${artist.spotify_id}`"
      @click.prevent.stop="
        navigateToSpotify(
          `https://open.spotify.com/intl-es/artist/${artist.spotify_id}`
        )
      "
    >
      <icon :size="24" :img="require('@/assets/images/ic-spotify-white.svg')" />
    </a>
    <div class="absolute artist-name">{{ artist.name }}</div>
  </a>
</template>

<script setup>
import Icon from "@/components/general/ui/elements/WIcon.vue";

import { computed } from "vue";

const props = defineProps({
  artist: {
    type: Object,
    default: () => {
      return {};
    }
  },
  openLink: {
    type: Boolean,
    default: true
  },
  isLink: {
    type: Boolean,
    default: true
  }
});
const artistImage = computed(() => {
  if (props.artist.thumbnails?.s_sq) {
    return props.artist.thumbnails.s_sq;
  } else if (props.artist.image_url) {
    return props.artist.image_url;
  } else {
    return require("@/assets/images/artist-placeholder.svg");
  }
});

const navigateToSpotify = url => {
  window.open(url, "_blank");
};
</script>

<style lang="scss" scoped>
.artist-card {
  height: 200px;
  width: 200px;
  border-radius: 5px;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: 900px) {
    height: 150px;
    width: 150px;
    border-radius: 10px;
  }

  .spotify-icon {
    left: 12px;
    bottom: 8px;
  }
  .artist-name {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    right: 12px;
    bottom: 8px;
    width: 70%;
    z-index: 4;
    text-align: right;
    pointer-events: none;
  }
}
</style>
